import React from 'react';
import { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';
import {images} from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';

const abouts = [
  {title: 'Web Designer', description: 'I love to design web apps as I know good design means good buisness', imgUrl: `${images.about01}`},
  {title: 'Content Writer', description: 'Crafting blogs that resonates my knowledge, inviting readers to explore and connect', imgUrl: `${images.about03}`},
  {title: 'Open Source', description: 'Open Source Enthusiast, exploring & learning how to contribute to large codebases', imgUrl: `${images.about02}`},
  {title: 'Communication', description: 'Communication is my strength & the linchpin that shapes my strong interpersonal skills', imgUrl: `${images.communication}`},
]

const About = () => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [about, setAbout] = useState([]);
  

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    
    
      setAbout(abouts);
    
    
  }, []);

  
  return (
    <>
      <h2 className="head-text">Good Developer 🧑‍💻 builds <span>Good Design </span> <br />Good Design means  <span>Good Buisness 📈</span></h2>
      
      <div className="app__about-wrapper">

        <div className="app__aboutme">
          
            <h3 className="head-text-small">
              <span>About Me</span> 
            </h3>

            <p className="p-text-large">
              <li>✅ Passionate Frontend Developer with a keen eye for user-centric design and a knack for transforming creative ideas into stunning, functional web applications.</li>
              <li>✅ Armed with a strong mentality on learning foundations of Web Technologies, thriving on creating seamless, responsive, and visually appealing user interfaces. Collaborating with cross-functional teams to deliver pixel-perfect websites.</li>
              <li>✅ Eager to stay at the forefront of emerging web technologies, enthusiasm for Open Source & consistently push the boundaries of what's possible in the world of frontend development.</li>
            </p>

            <a href={images.resume} download="Sameeksh's_Resume" className="p-text" >Resume/CV 👈</a>
        </div>

        <div className="app__profiles">

          {about.length && (
            <>
              <motion.div
                whileInView={{ opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.5, type: 'tween' }}
                className="app__profile-item"
                key={about.title + currentIndex}
              >
                
                  <img src={about[currentIndex].imgUrl} alt={about[currentIndex].title} />
                  <h2 className="bold-text" style={{ marginTop: 20 }}>{about[currentIndex].title}</h2>
                  <p className="p-text" style={{ marginTop: 10 }}>{about[currentIndex].description}</p>
                
                
              </motion.div>

              <div className="app__aboutme-btns app__flex">
                <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? about.length - 1 : currentIndex - 1)}>
                  <HiChevronLeft />
                </div>

                <div className="app__flex" onClick={() => handleClick(currentIndex === about.length - 1 ? 0 : currentIndex + 1)}>
                  <HiChevronRight />
                </div>
              </div>

            </>

            

          )}

          {/* {abouts.map((about, index) => (
            <motion.div
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__profile-item"
              key={about.title + index}
            >
      
              <img src={about.imgUrl} alt={about.title} />
              <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
              <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
            </motion.div>
          ))} */}


            
        </div>
      </div>
      
    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);

// export default About;
